import { createSelector } from 'reselect'

export const pagebreaksBool = createSelector(
	(state) => state.customForm.addOrEdit.form.sections,
	(state) => state.customForm.addOrEdit.sectionsByID,
	(sections, sectionsByID) =>
		Boolean(
			sections
				.map((id, idx) => ({
					...sectionsByID[id],
				}))
				.filter((el) => el?.type === 'pagebreak').length,
		),
)
